import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetRotationPurposesInputDto, RotationPurposeCreateDto, RotationPurposeDto, RotationPurposeExcelDownloadDto, RotationPurposeUpdateDto } from '../dtos/rotation-purpose/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class RotationPurposeService {
  private restService = inject(RestService);
  apiName = 'Planning';
  

  create = (input: RotationPurposeCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RotationPurposeDto>({
      method: 'POST',
      url: '/api/planning/rotationPurposes',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/planning/rotationPurposes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/planning/rotationPurposes',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RotationPurposeDto>({
      method: 'GET',
      url: `/api/planning/rotationPurposes/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/planning/rotationPurposes/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetRotationPurposesInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<RotationPurposeDto>>({
      method: 'GET',
      url: '/api/planning/rotationPurposes',
      params: { name: input.name, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: RotationPurposeExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/planning/rotationPurposes/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RotationPurposeDto[]>({
      method: 'GET',
      url: '/api/planning/rotationPurposes/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: RotationPurposeUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, RotationPurposeDto>({
      method: 'PUT',
      url: `/api/planning/rotationPurposes/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}